import { render } from "./Development.vue?vue&type=template&id=30fb587f&scoped=true"
import script from "./Development.vue?vue&type=script&lang=js"
export * from "./Development.vue?vue&type=script&lang=js"

import "./Development.vue?vue&type=style&index=0&id=30fb587f&scoped=true&lang=scss"
import "./Development.vue?vue&type=style&index=1&id=30fb587f&scoped=true&lang=scss"

import exportComponent from "C:\\project\\OfficialWebsite360\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30fb587f"]])

export default __exports__